import { render, staticRenderFns } from "./mainSlide.vue?vue&type=template&id=6e44f288&scoped=true&"
import script from "./mainSlide.vue?vue&type=script&lang=js&"
export * from "./mainSlide.vue?vue&type=script&lang=js&"
import style0 from "./mainSlide.vue?vue&type=style&index=0&id=6e44f288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e44f288",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VFooter,VIcon,VImg,VResponsive,VRow,VSpacer})
